<iframe
  [src]="href | safe"
  title="Trapo-Komponente"
  style="flex: 1; border: unset"
>
</iframe>
